<template>
  <el-form class="page-search" :inline="true">
    <el-form-item label="选择日期" style="margin-bottom: 16px">
      <el-date-picker
        v-model="search.data.date_created_range"
        type="daterange"
        size="small"
        clearable
        style="width: 240px"
      />
    </el-form-item>
    <el-form-item style="margin-bottom: 16px">
      <el-button type="primary" size="small" @click="onSubmit">
        查询
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import _ from 'lodash'
import store from './push-log.store'

export default {
  data() {
    return {
      search: store.search
    }
  },

  methods: {
    onSubmit() {
      store.onPushCountClick(true)
    }
  }
}
</script>
